<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> {{$t('pages.balanceEmpower.breadcrumb')}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container">
            <div>
                <div class="handle-headleft">
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="handleAdd">{{$t('pages.balanceEmpower.add')}}</el-button>
                    <el-button type="danger" icon="el-icon-delete" @click="delAllSelection">{{$t('pages.balanceEmpower.delete')}}</el-button>
                </div>
                <div class="handle-headright">
                    <el-input v-model="query.Field1" @blur="getData()" class="handle-select mr10" :placeholder="$t('pages.balanceEmpower.searchPh')"></el-input>
                    <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.balanceEmpower.search')}}</el-button>
                </div>
            </div>

            <el-table :data="balanceEmpowers" border class="table" ref="multipleTable" :element-loading-text="$t('pages.balanceEmpower.loading')" v-loading="loading" header-cell-class-name="table-header" @selection-change="handleSelectionChange" @row-dblclick="dbSelected" :height="tableHeight">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column type="index" width="50" :label="$t('pages.balanceEmpower.index')"></el-table-column>
                <el-table-column sortable prop="userName" :label="$t('pages.balanceEmpower.user')" width="150"></el-table-column>
                <!-- <el-table-column prop="balanceNames" label="设备"></el-table-column> -->
                <el-table-column prop="content" :label="$t('pages.balanceEmpower.device')">
                    <template slot-scope="scope">
                        <el-popover trigger="hover" placement="top-start" :title="$t('pages.balanceEmpower.detail')">
                            <p>{{ scope.row.balanceNames }}</p>
                            <div slot="reference" class="name-wrapper">{{ scope.row.balanceNames | ContentFormat }}</div>
                        </el-popover>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="modifyUserId" label="操作人"></el-table-column> -->
                <el-table-column sortable prop="modifyDate" :label="$t('pages.balanceEmpower.modifyTime')" width="140">
                    <template slot-scope="scope">{{ scope.row.modifyDate | formateData }}</template>
                </el-table-column>
                <el-table-column :label="$t('pages.balanceEmpower.operation')" width="110" align="center">
                    <template slot-scope="scope">
                        <!-- <el-button type="text" icon="el-icon-tickets" @click="handleShow(scope.row.id, scope.row)">查看 </el-button> -->
                        <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row.id, scope.row)">{{$t('pages.balanceEmpower.edit')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
            </div>
        </div>
        <!-- 编辑弹出框 -->
        <el-dialog :title="headTitle" :visible.sync="editVisible" width="30%" :close-on-click-modal="false">
            <el-form ref="balanceEmpower" :model="balanceEmpower" :rules="rules" label-width="90px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$t('pages.balanceEmpower.user')" prop="userId">
                            <el-select v-model="balanceEmpower.userId" class="size-full" @change="chgUser">
                                <el-option v-for="item in UserArr" :key="item.id" :label="item.realName" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$t('pages.balanceEmpower.device')">
                            <el-select multiple collapse-tags v-model="balanceEmpower.checkedBalances" class="size-full" filterable @change="chgBalance" :placeholder="$t('pages.balanceEmpower.selectPh')">
                                <el-option-group v-for="group in balanceArrGroup" :key="group.label" :label="group.label">
                                    <el-option v-for="item in group.options" :key="item.id" :label="item.mineName +':'+ item.name" :value="item.id"></el-option>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$t('pages.balanceEmpower.deviceDisplay')">{{ balanceEmpower.balanceNames }}</el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">{{$t('pages.balanceEmpower.cancel')}}</el-button>
                <el-button type="primary" @click="saveEdit('balanceEmpower')">{{$t('pages.balanceEmpower.confirm')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { GroupbyName, SortField } from '../../utils/helper';
let that;
export default {
    name: 'balanceEmpower',
    data: function () {
        return {
            isIndeterminate: true,

            tableHeight: window.innerHeight * 0.6,
            headTitle: '',
            viewVisible: false,
            isadd: false,
            balanceEmpower: {
                userId: '',
                userName: '',
                balanceIds: '',
                balanceNames: '',
                checkedBalances: []
            },
            balanceArr: [],
            UserArr: [],
            balanceArrGroup: [],
            editVisible: false,
            balanceEmpowers: [],
            pageCount: 1,
            multipleSelection: [],
            delList: [],
            loading: false,
            query: {
                Field1: '',
                PageIndex: 1,
                PageSize: 15
            },
            FrequencyArr: [],
            rules: {
                userId: [
                    {
                        required: true,
                        message: this.$t('pages.balanceEmpower.valid.userRequired'),
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    filters: {
        ContentFormat(content) {
            if (content.length >= 60) {
                content = content.substr(0, 60) + '...';
            }
            return content;
        }
    },
    created() {
        this.getData();
        this.getBalances();
        this.getUsers();
    },
    methods: {
        saveEdit() {
            this.$refs['balanceEmpower'].validate((valid) => {
                if (valid) {
                    this.balanceEmpower.balanceIds = this.balanceEmpower.checkedBalances.join(',');
                    if (this.isadd) {
                        this.$zybhttp
                            .post('balanceEmpower/balanceEmpowerAdd', this.balanceEmpower)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success('添加成功');
                                    this.getData();
                                    this.editVisible = false;
                                    this.balanceEmpower = {};
                                } else {
                                    this.$notify.error(res.data.msg);
                                }
                            })
                .catch((err) => this.$notify.error(this.$t('pages.balanceEmpower.addError')));
                    } else {
                        this.$zybhttp
                            .post('balanceEmpower/balanceEmpowerUpdate', this.balanceEmpower)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success('修改成功');
                                    this.getData();
                                    this.editVisible = false;
                                } else {
                                    this.$notify.error('修改失败');
                                }
                            })
                .catch((err) => this.$notify.error(this.$t('pages.balanceEmpower.updateError')));
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        getData() {
            // this.loading=true;
            this.$zybhttp
                .post('balanceEmpower/GetList', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('Id', 'desc'));
                        this.balanceEmpowers = newdata;
                        this.pageCount = res.data.total || 0;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.balanceEmpower.fetchError')));
        },
        getBalances() {
            this.$zybhttp
                .get('Balance/GetBalance', {
                    params: { balanceId: '' }
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;

                        for (var i = 0; i < d.length; i++) {
                            var item = d[i];
                            if (item.balanceType == '1') {
                                item.balanceTypeName = '皮带秤';
                            } else {
                                item.balanceTypeName = '给料机';
                            }
                        }
                        var dd = GroupbyName(d, 'balanceTypeName');
                        let narr = [];
                        for (var i = 0; i < dd.length; i++) {
                            var itemA = dd[i];
                            narr.push({ label: itemA.name, options: itemA.data });
                        }
                        //console.log(narr);
                        this.balanceArrGroup = narr;
                        this.balanceArr = d;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.balanceEmpower.fetchError')));
        },
        getUsers() {
            this.$zybhttp
                .get('BalanceEmpower/GetUserList', {
                    params: { userId: '' }
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.UserArr = d;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.balanceEmpower.fetchError')));
        },
        handleEdit(id, row) {
            this.getBalances();
            this.balanceEmpower = JSON.parse(JSON.stringify(row)); // row;
            this.balanceEmpower.id = id;

            var d = this.balanceEmpower.balanceIds.split(',');
            var arr = [];
            for (var i = 0; i < d.length; i++) {
                arr.push(parseInt(d[i]));
            }

            this.balanceEmpower.checkedBalances = arr;
            this.editVisible = true;
            this.isadd = false;
            this.headTitle = this.$t('pages.balanceEmpower.editTitle');
        },
        dbSelected(row) {
            this.getBalances();
            this.balanceEmpower = JSON.parse(JSON.stringify(row));
            var d = this.balanceEmpower.balanceIds.split(',');
            var arr = [];
            for (var i = 0; i < d.length; i++) {
                arr.push(parseInt(d[i]));
            }

            this.balanceEmpower.checkedBalances = arr;
            this.balanceEmpower.id = row.id;
            this.editVisible = true;
            this.isadd = false;
            this.headTitle = this.$t('pages.balanceEmpower.editTitle');
            // console.log(row);
        },
        handleShow(index, row) {
            this.balanceEmpower = row;
            this.viewVisible = true;
        },
        handleAdd() {
            this.getBalances();
            var ms_userInfo = localStorage.getItem('ms_userInfo');
            var userinfo = JSON.parse(ms_userInfo);
            this.balanceEmpower = {};
            this.isadd = true;
            let date = new Date();
            // this.balanceEmpower.CreateDate = dateFormat.formatDate(date, 'yyyy-MM-dd hh:mm:ss');
            this.balanceEmpower.createUserId = userinfo.loginId;
            this.balanceEmpower.modifyUserId = userinfo.loginId;
            this.editVisible = true;
            this.headTitle = this.$t('pages.balanceEmpower.addTitle');
        },
        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            let strValue = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].userName + ' ';
                strValue += this.multipleSelection[i].id + ',';
            }
            if (strValue.length == 0) {
                this.$notify.warning(this.$t('pages.balanceEmpower.warn.selectToDelete'));
                return;
            }
            this.$confirm(this.$t('pages.balanceEmpower.confirmDelete'), this.$t('pages.balanceEmpower.tip'), {
                type: 'warning'
            })
                .then(() => {
                    this.$zybhttp
                        //.get('balanceEmpower/balanceEmpowerDel?ids=1')
                        .get('balanceEmpower/balanceEmpowerDel', {
                            params: { ids: strValue }
                        })
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success(`删除了【${str}】的设备权限`);
                                this.getData();
                            } else {
                                this.$notify.error(res.data.msg);
                            }
                        })
                        .catch((err) => this.$notify.error(this.$t('pages.balanceEmpower.deleteError')));
                    this.multipleSelection = [];
                })
                .catch(() => {});
        },
        indexMethod(index) {
            return index + 1;
        },
        chgBalance(e) {
            let obj = [];
            this.balanceArr.map((item) => {
                //  this.unitList 是你 select option遍历的集合 e 是选中的id
                if (e.indexOf(item.id) > -1) {
                    obj.push(item.mineName +':'+ item.name);
                }
            });
            this.balanceEmpower.balanceNames = obj.join(',');
        },
        chgUser(e) {
            var realName = this.UserArr.filter((x) => x.id == e)[0].realName;
            this.balanceEmpower.userName = realName;
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}
.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.size-full {
    width: 100%;
}
</style>
